import { render, staticRenderFns } from "./RefsPartnerBanking.vue?vue&type=template&id=9f8c5bfe&scoped=true"
import script from "./RefsPartnerBanking.vue?vue&type=script&lang=ts"
export * from "./RefsPartnerBanking.vue?vue&type=script&lang=ts"
import style0 from "./RefsPartnerBanking.vue?vue&type=style&index=0&id=9f8c5bfe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8c5bfe",
  null
  
)

export default component.exports